const options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
} as const;

export const getDate = (dateString?: string) => {
  if (!dateString) return '';

  return new Date(dateString).toLocaleDateString('en-EN', options);
};
